import styles from './style.module.scss';
import { Col, Row, Spin, Table, Typography } from 'antd';
import useStoreVsVillagePages from '../useInvoicesSalesCompetitors';
import LineChart from '../../../charts/lineChart';
import PrintFilterText from '../../printFiiterText';

const Print = ({
  allReports = false,
  allReportsData,
  isAllReports,
  isMain,
}) => {
  const {
    data,
    columns,
    summary,
    loading,
    title,
    searchParams,
    format,
    filters,
  } = useStoreVsVillagePages(true, allReportsData, isAllReports);
  if (!isMain) {
    localStorage.setItem('auth_token', searchParams.get('token'));
  }

  const byCompany = searchParams.get('by_company');
  const byPeriod = searchParams.get('by_period');
  const byShoppingCenter = searchParams.get('by_shopping_center');

  const searchParamsObj = Object.fromEntries([...searchParams]);
  const searchParamsObjKeys = Object.keys(searchParamsObj);
  const availableFilters = filters.filter((i) =>
    searchParamsObjKeys.includes(i.name),
  );

  return (
    <>
      <div className={styles.container}>
        {byCompany && byPeriod && byShoppingCenter && (
          <Spin spinning={loading}>
            {!allReports && (
              <Row className={styles.titleSection} justify={'center'}>
                <Col>
                  <Typography.Title level={3}>{title}</Typography.Title>
                </Col>
                <PrintFilterText
                  availableFilters={availableFilters}
                  searchParams={searchParams}
                />
              </Row>
            )}
            {allReports && (
              <Row className={styles.titleSection} justify={'center'}>
                <Col>
                  <Typography.Title level={3}>
                    SALES TREND: STORE vs COMPETITORS
                  </Typography.Title>
                </Col>
              </Row>
            )}
            <br />
            <Row>
              <Col xs={24} xxl={12}>
                <Table
                  columns={columns}
                  dataSource={data.tableData}
                  pagination={{
                    pageSize: 10000,
                    position: ['bottomCenter'],
                    hideOnSinglePage: true,
                    showSizeChanger: false,
                  }}
                  bordered
                  scroll={{}}
                  summary={summary}
                  loading={loading}
                />
              </Col>
              <Col span={12} className={'chartColl'}>
                <LineChart
                  data={data.lineChartData}
                  tableData={data.tableData}
                  colors={['#61cdbb', '#f47560', '#e8a838']}
                  itemWidth={150}
                  format={format}
                />
              </Col>
            </Row>
          </Spin>
        )}
      </div>
    </>
  );
};

export default Print;
